<header class="hdr" id="app-store-header" [class.scrolled]="isScrolled()">
  <div class="hdr-in">
    <div class="hdr-pill hdr-left">
      <a class="hdr-logo" (click)="navigateTo('/')">
        <img
          src="assets/icons/logo/LogoBig.svg"
          alt="Reforce — платформа безопасности"
          class="hdr-logo__img hdr-logo__img--full"
        />
        <img
          src="assets/icons/logo/LogoMini.svg"
          alt=""
          class="hdr-logo__img hdr-logo__img--mini"
          aria-hidden="true"
        />
      </a>
      <span class="hdr-sep"></span>
      <app-areas class="hdr-areas" />
    </div>

    <nav class="hdr-pill hdr-nav" aria-label="Основная навигация">
      <a
        class="nav-lnk"
        routerLink="/"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="{ exact: true }"
        (click)="metrika.reachGoal(goals.navMain)"
      >
        Главная
      </a>
      <a
        class="nav-lnk"
        routerLink="/dom"
        routerLinkActive="is-active"
        (click)="metrika.reachGoal(goals.navForHome)"
      >
        Для дома
      </a>
      <a
        class="nav-lnk"
        routerLink="/biznes"
        routerLinkActive="is-active"
        (click)="metrika.reachGoal(goals.navForBusiness)"
      >
        Для бизнеса
      </a>
      <a
        class="nav-lnk"
        routerLink="/partner"
        routerLinkActive="is-active"
        (click)="metrika.reachGoal(goals.navForPartners)"
      >
        Для партнёров
      </a>
      <a class="nav-lnk" routerLink="/katalog" routerLinkActive="is-active">Каталог</a>
      <a class="nav-lnk" routerLink="/configurator" routerLinkActive="is-active">Подбор</a>
      <div class="nav-about">
        <button
          type="button"
          class="nav-lnk nav-about__trigger"
          [class.is-active]="isAboutRouteActive()"
          [class.is-open]="isOpenAboutMenu()"
          [attr.aria-expanded]="isOpenAboutMenu()"
          (click)="toggleAboutMenu()"
        >
          О нас
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.4"
            stroke-linecap="round"
            stroke-linejoin="round"
            aria-hidden="true"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </button>
        @if (isOpenAboutMenu()) {
          <div class="nav-about__menu">
            <a routerLink="/contacts" routerLinkActive="is-active" (click)="closeAboutMenu()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m22 7-10 6L2 7" />
              </svg>
              Контакты
            </a>
            <a routerLink="/career" routerLinkActive="is-active" (click)="closeAboutMenu()">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.8"
                stroke-linecap="round"
                stroke-linejoin="round"
                aria-hidden="true"
              >
                <rect x="2" y="7" width="20" height="14" rx="2" />
                <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
              </svg>
              Вакансии
            </a>
          </div>
        }
      </div>
      <button type="button" class="nav-call" (click)="showDialogCall(call)">Заказать звонок</button>
    </nav>

    <div class="hdr-right">
      <div class="hdr-pill hdr-right__pill">
        <button
          type="button"
          class="hdr-ic-m call"
          aria-label="Заказать звонок"
          (click)="showDialogCall(call)"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
              d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.4.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.4 0 .7-.2 1l-2.3 2.2z"
            />
          </svg>
        </button>
        @if (userInfo$ | async) {
          <button
            type="button"
            class="hdr-ic-m hdr-profile-trigger"
            [class.is-active]="isOpenProfilePopup()"
            [attr.aria-expanded]="isOpenProfilePopup()"
            aria-label="Открыть профиль"
            (click)="toggleProfilePopup()"
          >
            <tui-icon icon="@tui.user" />
          </button>
        } @else {
          <button
            type="button"
            class="hdr-ic-m hdr-profile-trigger"
            aria-label="Войти в личный кабинет"
            [disabled]="loadingOIDC()"
            (click)="login()"
          >
            <tui-icon icon="@tui.user" />
          </button>
        }
        <button
          type="button"
          class="hdr-burger"
          [attr.aria-expanded]="isOpenPopupMenu()"
          [attr.aria-label]="isOpenPopupMenu() ? 'Закрыть меню' : 'Открыть меню'"
          (click)="toggleBurgerMenu()"
        >
          <span class="hdr-burger__graphic" aria-hidden="true">
            @if (isOpenPopupMenu()) {
              <svg
                class="hdr-burger__icon-close"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 5L19 19M19 5L5 19"
                  stroke="currentColor"
                  stroke-width="2.25"
                  stroke-linecap="round"
                />
              </svg>
            } @else {
              <tui-icon class="hdr-burger__icon-menu" icon="@tui.menu" />
            }
          </span>
        </button>
      </div>

      @if (isOpenProfilePopup()) {
        @if (userInfo$ | async; as userInfo) {
          <div
            class="hdr-profile-pop"
            role="dialog"
            aria-modal="false"
            aria-label="Профиль пользователя"
          >
            <div class="hdr-profile-pop__head">
              <span class="hdr-profile-pop__avatar"><tui-icon icon="@tui.user" /></span>
              <span class="hdr-profile-pop__user">
                <strong>{{ getHeaderUserName(userInfo) }}</strong>
                @if (userInfo.phone; as phone) {
                  <small>{{ phone | phone }}</small>
                }
                @if (userInfo.email) {
                  <small>{{ userInfo.email }}</small>
                }
              </span>
            </div>
            <button type="button" class="hdr-profile-pop__logout" (click)="logout()">
              <tui-icon icon="@tui.log-out" />
              Выйти
            </button>
          </div>
        }
      }

      @if (isOpenPopupMenu()) {
        <div class="hdr-pop" role="dialog" aria-modal="false" aria-label="Меню">
          <div class="pop-account">
            @if (userInfo$ | async; as userInfo) {
              <div class="pop-user-card">
                <tui-icon class="pop-btn__icon" icon="@tui.user" />
                <span class="pop-user">
                  <strong>{{ getHeaderUserName(userInfo) }}</strong>
                  @if (userInfo.phone; as phone) {
                    <small>{{ phone | phone }}</small>
                  }
                </span>
              </div>
              <button
                type="button"
                class="pop-btn"
                [class.is-active]="isActiveRoute('orders')"
                (click)="navigateToAndCloseBurger('orders')"
              >
                <tui-icon class="pop-btn__icon" icon="@tui.package" />
                Заказы
              </button>
            } @else {
              <tui-loader [loading]="loadingOIDC()" [overlay]="true">
                <button type="button" class="pop-btn" (click)="loginFromBurger()">
                  <tui-icon class="pop-btn__icon" icon="@tui.user" />
                  Личный кабинет
                </button>
              </tui-loader>
              <tui-loader [loading]="loadingOIDC()" [overlay]="true">
                <button type="button" class="pop-btn" (click)="loginFromBurger('/orders')">
                  <tui-icon class="pop-btn__icon" icon="@tui.package" />
                  Заказы
                </button>
              </tui-loader>
            }
          </div>

          <div class="pop-div"></div>

          <!-- Ссылки-страницы дублируют .hdr-nav — показываем их в попапе только
               тогда, когда сама .hdr-nav скрыта в шапке (см. @media в .pop-nav-wrap). -->
          <div class="pop-nav-wrap">
            <nav class="pop-nav" aria-label="Основная навигация">
              <a
                class="pop-lnk"
                routerLink="/"
                routerLinkActive="is-active"
                [routerLinkActiveOptions]="{ exact: true }"
                (click)="closeBurgerMenu(); metrika.reachGoal(goals.navMain)"
              >
                <tui-icon class="pop-lnk__icon" icon="@tui.house" />
                Главная
              </a>
              <a
                class="pop-lnk"
                routerLink="/dom"
                routerLinkActive="is-active"
                (click)="closeBurgerMenu(); metrika.reachGoal(goals.navForHome)"
              >
                <tui-icon class="pop-lnk__icon" icon="@tui.house-wifi" />
                Для дома
              </a>
              <a
                class="pop-lnk"
                routerLink="/biznes"
                routerLinkActive="is-active"
                (click)="closeBurgerMenu(); metrika.reachGoal(goals.navForBusiness)"
              >
                <tui-icon class="pop-lnk__icon" icon="@tui.shield-check" />
                Для бизнеса
              </a>
              <a
                class="pop-lnk"
                routerLink="/partner"
                routerLinkActive="is-active"
                (click)="closeBurgerMenu(); metrika.reachGoal(goals.navForPartners)"
              >
                <tui-icon class="pop-lnk__icon" icon="@tui.handshake" />
                Для партнёров
              </a>
              <a
                class="pop-lnk"
                routerLink="/katalog"
                routerLinkActive="is-active"
                (click)="closeBurgerMenu()"
              >
                <tui-icon class="pop-lnk__icon" icon="@tui.layout-grid" />
                Каталог
              </a>
              <a
                class="pop-lnk"
                routerLink="/configurator"
                routerLinkActive="is-active"
                (click)="closeBurgerMenu()"
              >
                <tui-icon class="pop-lnk__icon" icon="@tui.sliders" />
                Подбор решения
              </a>
              <a
                class="pop-lnk"
                routerLink="/career"
                routerLinkActive="is-active"
                (click)="closeBurgerMenu()"
              >
                <tui-icon class="pop-lnk__icon" icon="@tui.briefcase" />
                Вакансии
              </a>
              <a
                class="pop-lnk"
                routerLink="/contacts"
                routerLinkActive="is-active"
                (click)="closeBurgerMenu()"
              >
                <tui-icon class="pop-lnk__icon" icon="@tui.mail" />
                Контакты
              </a>
            </nav>

            <div class="pop-div"></div>
          </div>

          <!-- Город дублирует .hdr-left app-areas — в попапе он нужен только тогда,
               когда сама она скрыта в шапке (см. @media в .pop-areas-wrap). -->
          <div class="pop-areas-wrap">
            <app-areas class="pop-areas" [hintEnabled]="false" />

            <div class="pop-div"></div>
          </div>

          <a class="pop-phone" [href]="hotline.telHref" (click)="closeBurgerMenu()">
            {{ hotline.text }}
          </a>
          <button type="button" class="pop-call" (click)="showDialogCall(call); closeBurgerMenu()">
            Заказать звонок
          </button>
          @if (userInfo$ | async) {
            <button type="button" class="pop-logout" (click)="logout()">
              <tui-icon icon="@tui.log-out" />
              Выйти
            </button>
          }
        </div>
      }
    </div>
  </div>

  @if (isWelcomeVisible()) {
    @if (userInfo$ | async; as userInfo) {
      <aside class="hdr-welcome" role="status">
        <button
          type="button"
          class="hdr-welcome__close"
          aria-label="Закрыть"
          (click)="closeWelcome()"
        >
          ×
        </button>
        <strong>Здравствуйте, {{ getHeaderUserName(userInfo) }}!</strong>
        <span>Вы вошли в личный кабинет</span>
      </aside>
    }
  }
</header>

<ng-template #profile>
  <div class="profile">
    @if (userInfo$ | async; as userInfo) {
      <div class="profile__info">
        <img
          class="profile__icon"
          [src]="'assets/icons/navbar/Profile.svg'"
          alt=""
          width="50"
          height="50"
        />

        <div class="profile__user">
          <div class="profile__name">
            @if (userInfo.surname && userInfo.surname.length) {
              <p class="profile__text">{{ userInfo.surname }}</p>
            }

            @if (userInfo.name && userInfo.name.length) {
              <p class="profile__text">{{ userInfo.name[0] }}.</p>
            }

            @if (userInfo.second_name && userInfo.second_name.length) {
              <p class="profile__text">{{ userInfo.second_name[0] }}.</p>
            }
          </div>

          @if (userInfo.phone && userInfo.phone.length) {
            <p class="profile__text">{{ userInfo.phone | phone }}</p>
          }
        </div>
      </div>
      <tui-loader [loading]="loadingOIDC()" [overlay]="true">
        <button class="profile__btn" (click)="logout()">Выйти</button>
      </tui-loader>
    } @else {
      <tui-loader [loading]="true" [size]="'xl'" style="padding: 2rem" />
    }
  </div>
</ng-template>

<ng-template #navMenu>
  <nav class="nav-menu" aria-label="Основная навигация">
    <a
      class="nav-menu__link"
      routerLink="/"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: true }"
      (click)="closeNavMenu()"
    >
      Главная
    </a>
    <a
      class="nav-menu__link"
      routerLink="/dom"
      routerLinkActive="is-active"
      (click)="closeNavMenu()"
    >
      Для дома
    </a>
    <a
      class="nav-menu__link"
      routerLink="/biznes"
      routerLinkActive="is-active"
      (click)="closeNavMenu()"
    >
      Для бизнеса
    </a>
    <a
      class="nav-menu__link"
      routerLink="/partner"
      routerLinkActive="is-active"
      (click)="closeNavMenu()"
    >
      Для партнёров
    </a>
    <a
      class="nav-menu__link"
      routerLink="/katalog"
      routerLinkActive="is-active"
      (click)="closeNavMenu()"
    >
      Каталог
    </a>
    <a
      class="nav-menu__link"
      routerLink="/configurator"
      routerLinkActive="is-active"
      (click)="closeNavMenu()"
    >
      Подбор решения
    </a>
    <a
      class="nav-menu__link"
      routerLink="/career"
      routerLinkActive="is-active"
      (click)="closeNavMenu()"
    >
      Карьера
    </a>
  </nav>
</ng-template>

<ng-template #call>
  <app-call />
</ng-template>
